export default __webpack_public_path__ + "static/char-s-sp02-chs-264ca4dcb9ac9c756b6b2196cf423eb3.png";